import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect } from "@/mixins/index";
import { Message } from "element-ui";
import { addSenstityList, returnData, updataSentityList } from "@/api/dataAll/senstityWord";
export default {
  name: "addSentityword",
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  mixins: [serchSelect],
  data: function data() {
    return {
      dialogFormVisible: false,
      titleName: "",
      searchData: {
        id: "",
        game: "",
        sensitive_word: ''
      },
      rules: {
        sensitive_word: [{
          required: true,
          message: this.$t('pleaseUseEnglishComma'),
          trigger: "blur"
        }],
        game: [{
          required: true,
          message: this.$t('game'),
          trigger: "blur"
        }] // parameter: [{ required: true, message: "参数", trigger: "blur" }],

      },
      formLabelWidth: "80px"
    };
  },
  created: function created() {},
  computed: {
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  },
  methods: {
    init: function init(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (row && row.id) {
                  _this.searchData = _objectSpread({}, row);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm() {
      this.dialogFormVisible = false;
      this.clearData(true);
      this.$emit("changeShow", false);
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.form.validate(function (vaild) {
        if (vaild) {
          var data = {
            game_id: _this2.rawData.game_id,
            id: _this2.searchData.id,
            sensitive_word: _this2.searchData.sensitive_word
          };
          var reqFn = _this2.searchData.id ? updataSentityList : addSenstityList;
          reqFn(data).then(function (res) {
            if (res.status == 200) {
              Message.success(res.message);
              _this2.searchData.id = '';

              _this2.resetForm("ruleForm");

              _this2.$emit("refreshDataList");
            }
          });
        }
      });
    },
    clearData: function clearData(type) {
      this.searchData = {
        id: type ? '' : this.searchData.id,
        sensitive_word: '',
        game: this.searchData.game
      };
      this.$refs.form.resetFields();
    }
  }
};